@if(frameURL()) {
<iframe
  class="absolute-center w-full h-full rounded-6"
  [src]="frameURL()"
  frameborder="0"
  (load)="onLoad()"
></iframe>
}
@if (!isLoaded() && !frameURL()) {
<svg-icon
  class="absolute-center loading-animation flex items-center justify-center s-14"
  src="assets/icons/ui/loading.svg"
/>
}
